import { DateTime } from 'luxon';
import { computed } from 'vue';
import { useSettings } from '~/composables/useSettings';

export const useDate = (date: string) => {
  const { websiteTimezone } = useSettings();

  const dateLuxon = computed<DateTime>(() => DateTime.fromISO(date, { zone: websiteTimezone.value || undefined }));

  const articleDate = computed<string>(() => dateLuxon.value.toFormat('LLLL dd, yyyy'));
  const day = computed<number>(() => dateLuxon.value.day);
  const monthShort = computed<string | null>(() => dateLuxon.value.monthShort);
  const time = computed<string>(() => dateLuxon.value.toFormat('t ZZZZ'));

  return {
    articleDate,
    day,
    monthShort,
    time,
  };
};
